// neon.js
import chroma from 'chroma-js';
import { brushDefaults } from './helpers/brushLoader';
import { drawStrokeWithGradient } from './marker';
import { drawPlainStroke } from './helpers/plain';
import { getStrokeBounds, translatePoints } from './helpers/points'; 

const defaultBrushSettings = brushDefaults.neon || {};

export async function drawNeonStroke(stroke, context, params) {
  const {
    lineWidth,
    color,
    sets = {},
  } = stroke;

  const brushSettings = Object.assign({}, defaultBrushSettings, sets);
  const {
    neonSize = 20,
    opacity = 1,
  } = brushSettings;

  // const neonColor = color;
  const chromaColor = chroma(color);
  const originalAlpha = chromaColor.alpha();
  const middleAlphaColor = chromaColor.alpha(0.5);
  const neonColor = chromaColor.alpha(opacity).hex();
  // const neonColor = chromaColor.alpha(opacity).hex();

  // Вычисляем границы штриха
  const bounds = getStrokeBounds(stroke.points, lineWidth, neonSize * 2);
  if (!bounds) return;

  const offsetX = -bounds.x;
  const offsetY = -bounds.y;
  const translatedPoints = translatePoints(stroke.points, offsetX, offsetY);

  // Создаем временный канвас минимального размера
  const bufferCanvas = document.createElement('canvas');
  bufferCanvas.width = bounds.width;
  bufferCanvas.height = bounds.height;
  const bufferCtx = bufferCanvas.getContext('2d');

  // Рисуем черную тень
  bufferCtx.save();
  bufferCtx.globalCompositeOperation = 'source-over';
  bufferCtx.shadowColor = neonColor;
  bufferCtx.shadowBlur = neonSize * 2;
  for (let i = 0; i < 3; i++) {
    await drawStrokeWithGradient({
      ...stroke, 
      points: translatedPoints,
      lineWidth: lineWidth,
      color: originalAlpha < 0.5 ? middleAlphaColor : color,
    }, bufferCtx, brushSettings);
  }
  bufferCtx.restore();

  if (originalAlpha < 0.95) {

    // Рисуем внутреннюю часть, чтобы вычесть ее из обводки
    bufferCtx.globalCompositeOperation = 'destination-out';
    drawPlainStroke({
      ...stroke,
      points: translatedPoints,
      lineWidth: lineWidth + 1,
      color: 'black',
    }, bufferCtx, brushSettings);

    // Рисуем основной штрих
    bufferCtx.globalCompositeOperation = 'source-over';
    drawStrokeWithGradient({
      ...stroke,
      points: translatedPoints,
    }, bufferCtx, brushSettings)

  } 


  context.drawImage(
    bufferCanvas, 
    0, 0, bounds.width, bounds.height,
    bounds.x, bounds.y, bounds.width, bounds.height
  );

}
